import { jsx as _jsx } from "react/jsx-runtime";
import Avatar from "@sprout/client-components/dist/Avatar";
import { useNavigationListContext } from "@sprout/list-navigation";
import { useEffect, useState, useCallback } from "react";
import { Flex } from "sprout-ui-primitives";
import { themeGet } from "sprout-ui-theme";
import styled, { css } from "styled-components";
const PostPageAssigneesWrapper = styled(Flex)`
  > * {
    border: 1px solid ${themeGet("colors.white.100")};

    + * {
      margin-left: -6px;
    }
  }

  ${({ $assign  })=>$assign && css`
      cursor: pointer;
    `}
`;
const PostPageAssignees = (props)=>{
    const { assignees  } = props;
    const [assign, setAssign] = useState(false);
    const { currentlyActiveCommands , dispatchCommand  } = useNavigationListContext();
    useEffect(()=>{
        if (currentlyActiveCommands.includes("PAGE_ASSIGN")) setAssign(true);
    }, [
        currentlyActiveCommands
    ]);
    const handleClick = useCallback(()=>{
        dispatchCommand("PAGE_ASSIGN", null);
    }, [
        dispatchCommand
    ]);
    return /*#__PURE__*/ _jsx(PostPageAssigneesWrapper, {
        alignItems: "center",
        onClick: assign ? handleClick : undefined,
        $assign: assign,
        children: assignees.map((user)=>/*#__PURE__*/ _jsx(Avatar, {
                user: user,
                size: 32,
                navigable: !assign
            }, user.id))
    });
};
export default PostPageAssignees;
